import Vue from 'vue'
import Router from 'vue-router'

import { routes } from './routes'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes
})

router.beforeEach((to,from,next)=> {
   
  if (!to.matched.some(record => record.name==='index')) {

    try {
      var udata = JSON.parse(localStorage.getItem("udata"));

      // Session expired
      if (udata===null || typeof (udata.SessionID) === "undefined" || udata.expiry<new Date().getTime()) {
        next('/');
      }
      else {
        next();
      }
    }
    catch(e) {
      next("/");
    }

  }
  else {
    next();
  }
});

export default router
